import { Choice, ParentPathCustomization, PDCustomization } from "../api-models/order-pd-response.model";

export interface AdditionalOfferData {
    choiceCode: string;
    choice?: Choice;
    type?: OfferType;
    IncludedWithPackage?: any;
    customizationCode?: string;   
    accepted?: boolean; 
    usoc: string;
    value?: string;
}

export interface OfferFee {
    FeeRaw: string;
    Fee: number;
    FeeTerm: string;
    SalesTaxEstimate: string | null;
    FeeSingleMulti: string | null;
    AbpDiscount: string | null;
    FanDiscount: string | null;
    FanDiscountDesc: string | null;
    FeeLength: string | null;
    FeeTotal: string | null;
    PromoPriceDescription: string | null;
}

export enum OfferType {
    Required = 'Required',
    Optional = 'Optional',
    Additional = 'Additional',
    Equipment = 'Equipment',
    Voice = 'Voice'
}

export interface InternetOfferCustomization extends Omit<PDCustomization, 'Choices'> {
    Usoc?: string;
    Choices: Choice[];
    isDropdown: boolean;
    isPaired: boolean;
    isCheckbox?: boolean;
    AcceptChoiceCode: string | null;
    DeclineChoiceCode: string | null;
    ChoiceCode?: string;
    Fee?: Choice['Fee'];
    ImageUrl?: string | null;
    path: ParentPathCustomization[];
}

export interface InternetOffersView {
    includedOffers: InternetOfferCustomization[];
    additionalOffers: InternetOfferCustomization[];
    additionalVoiceOffers: InternetOfferCustomization[];
    additionalVoiceNewDirectoryListingOffers: InternetOfferCustomization[];
    additionalVoiceNewLongDistanceOffers: InternetOfferCustomization[];
    additionalVoiceNewCarrierFreezeOffers: InternetOfferCustomization[];
    additionalVoiceKeepDirectoryListingOffers: InternetOfferCustomization[];
    additionalVoiceKeepLongDistanceOffers: InternetOfferCustomization[];
    additionalVoiceKeepCarrierFreezeOffers: InternetOfferCustomization[];
    equipmentOffers: InternetOfferCustomization[];
}
